/* BC-TNDC-EN-ASSET 29-ago-2026 — este JS vivía dentro de bc-tendenze.liquid y viajaba en el
   HTML de cada página, duplicado (el snippet se pinta dos veces). Aquí se descarga una vez y se
   cachea. Engancha por delegación en document, así que funciona con el cajón pintado por AJAX. */

      (function () {
        if (window.__bcTndAdd) return;
        window.__bcTndAdd = true;

        var GENERICA = 'M';            // presente en las 13 prendas; S/M/L/XL lo estan, 2XL solo en 11
        var ES_TALLA = /tagli|size|talla/i;

        function nombresOpciones(prod) {
          return (prod.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; });
        }

        // Talla que ya lleva en el carrito. Si lleva varias, manda la primera.
        function tallaDelCarrito() {
          return fetch('/cart.js', { credentials: 'same-origin' })
            .then(function (r) { return r.json(); })
            .then(function (c) {
              var items = c.items || [];
              for (var i = 0; i < items.length; i++) {
                var ov = items[i].options_with_values || [];
                for (var j = 0; j < ov.length; j++) {
                  if (ES_TALLA.test(ov[j].name) && ov[j].value) return ov[j].value;
                }
              }
              return null;
            })
            .catch(function () { return null; });
        }

        // La variante se resuelve AQUI, en el clic, nunca al pintar la pagina (bug del 18-ago).
        function elegirVariante(prod, talla) {
          var idx = nombresOpciones(prod).findIndex(function (n) { return ES_TALLA.test(n); });
          var libres = (prod.variants || []).filter(function (v) { return v.available; });
          if (!libres.length) return null;
          if (idx >= 0 && talla) {
            var iguales = libres.filter(function (v) {
              return String((v.options || [])[idx] || '').toLowerCase() === String(talla).toLowerCase();
            });
            if (iguales.length) return iguales[0];
          }
          if (idx >= 0) {
            var gen = libres.filter(function (v) {
              return String((v.options || [])[idx] || '').toUpperCase() === GENERICA;
            });
            if (gen.length) return gen[0];
          }
          return libres[0];   // sin talla util: la primera disponible, que existe y tiene stock
        }

        // Al retirar una, entra la siguiente de la reserva: el hueco no se queda vacio.
        function quitarTarjeta(card) {
          var bloque = card.closest('.bc-tndc');
          card.remove();
          if (!bloque) return;
          var reserva = bloque.querySelector('.bc-tndc__card--reserva');
          if (reserva) reserva.classList.remove('bc-tndc__card--reserva');
          // Cuando se acaben las reservas Y las visibles, el bloque entero se retira.
          if (!bloque.querySelector('.bc-tndc__card')) bloque.remove();
        }

        document.addEventListener('click', function (e) {
          var b = e.target.closest('[data-bc-tnd-add]');
          if (!b) return;
          e.preventDefault();          // la tarjeta entera es un enlace: que no navegue
          e.stopPropagation();
          if (b.dataset.cargando) return;
          b.dataset.cargando = '1';
          b.classList.add('is-cargando');

          var handle = b.dataset.bcTndAdd;
          var card = b.closest('.bc-tndc__card');

          Promise.all([
            tallaDelCarrito(),
            fetch('/products/' + handle + '.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); })
          ])
            .then(function (res) {
              var v = elegirVariante(res[1], res[0]);
              if (!v) throw new Error('sin variante disponible');
              return fetch('/cart/add.js', {
                method: 'POST', credentials: 'same-origin',
                headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
                body: JSON.stringify({ id: v.id, quantity: 1 })
              });
            })
            .then(function (r) { return r.json(); })
            .then(function (data) {
              if (data.status && data.status !== 200) throw new Error(data.description || 'error');
              b.classList.remove('is-cargando');
              b.classList.add('is-hecho');
              if (document.body.classList.contains('template-cart')) { window.location.reload(); return; }
              document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: data } }));
              document.dispatchEvent(new CustomEvent('cart:build'));
              setTimeout(function () { if (card) quitarTarjeta(card); }, 700);
            })
            .catch(function () {
              // Si algo falla no se deja a la clienta sin salida: a la ficha, a elegir a mano.
              b.classList.remove('is-cargando');
              delete b.dataset.cargando;
              if (card) window.location.href = card.getAttribute('href');
            });
        });
      })();
      